<template>
  <div class="ma-0 pa-0">
    <v-card tile>
      <v-card-text class="mt-0">
        <v-chip class="mt-0" label color="transparent" text-color="black">
          <h3>
            Elegir Dia y Horario del Turno - Profesional:
            {{ nombreProfesional }}
          </h3>
        </v-chip>
        <!-- Info de precio visible antes de reservar -->
        <v-alert
          v-if="precioDisplay && precioDisplay.precioConsultaString"
          dense
          outlined
          :color="precioDisplay.esSena ? 'orange' : 'success'"
          class="mt-2 mb-0 mx-2"
        >
          <template v-if="precioDisplay.esSena && precioDisplay.precioFinalString">
            <span class="font-weight-bold">Seña requerida: {{ precioDisplay.precioConsultaString }}</span>
            <span class="mx-2">|</span>
            <span class="font-weight-bold">Precio total consulta: {{ precioDisplay.precioFinalString }}</span>
          </template>
          <template v-else>
            <span class="font-weight-bold">Precio de la consulta: {{ precioDisplay.precioConsultaString }}</span>
          </template>
        </v-alert>
      </v-card-text>
      <v-row class="turnos-wide-toolbar">
        <v-btn
          class="ml-4 mr-2"
          max-width="40px"
          min-width="40px"
          @click="retrocederSemana"
          tile
          color="blue"
          dark
          :disabled="date == fechaMinima"
        >
          <v-icon large>mdi-arrow-left-bold</v-icon>
        </v-btn>

        <v-menu
          v-if="!sinTurnos"
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFormatted"
              label="Semana del"
              @blur="date = date"
              readonly
              v-on="on"
              class="shrink"
              style="width: 88px"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            locale="es-ar"
            :first-day-of-week="1"
            @change="armarTurnos"
            :allowed-dates="allowedDates"
            :min="fechaMinima"
            :max="fechaMaxima"
          ></v-date-picker>
        </v-menu>

        <v-btn
          max-width="40px"
          min-width="40px"
          class="ml-2"
          @click="avanzarSemana"
          tile
          color="blue"
          dark
          :disabled="date >= fechaMaxima"
        >
          <v-icon large>mdi-arrow-right-bold</v-icon>
        </v-btn>
        <div class="referencia-turno-container">
          <div
            v-if="hayTurnosPresenciales"
            class="referencia-tipo-turno referencia-tipo-turno__presencial"
          >
            <v-icon color="white" small>mdi-walk</v-icon>
            <span>Turno Presencial</span>
          </div>
          <div
            v-if="hayTurnosVideoconsulta"
            class="referencia-tipo-turno referencia-tipo-turno__videoconsulta"
          >
            <v-icon color="white" small>mdi-video</v-icon>
            <span>Turno Videoconsulta</span>
          </div>
          <div
            v-if="hayTurnosEligePaciente"
            class="referencia-tipo-turno referencia-tipo-turno__elige-paciente"
          >
            <v-icon color="white" small>mdi-walk</v-icon>
            <v-icon color="white" small>mdi-video</v-icon>
            <span>Paciente elige modalidad</span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div v-if="loadingTurnos" class="loader mr-2"></div>
        <h4 v-if="loadingTurnos" class="mt-2">Reservando turno</h4>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>
    <v-row>
      <v-col cols="2" class="ma-0 pa-0">
        <v-data-table
          v-if="!sinTurnos"
          :headers="headerLunes"
          :items="this.listaTurnosLunes"
          dense
          @click:row="despliegaMenu"
          :hide-default-footer="true"
          :loading="isLoading"
          locale="es-ar"
          item-key="id"
          class="row-pointer"
          :item-class="rowClasses"
          :disable-sort="true"
          :items-per-page="500"
        ></v-data-table>

        <v-menu
          v-model="showMenu"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
        >
          <v-list dense>
            <v-list-item
              v-for="(item, index) in itemsMenu"
              :key="index"
              @click="definirAccion(item)"
            >
              <v-list-item-icon class="mr-2 pr-2">
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-data-table
          v-if="!sinTurnos"
          :headers="headerMartes"
          :items="this.listaTurnosMartes"
          dense
          @click:row="despliegaMenu"
          :hide-default-footer="true"
          :loading="isLoading"
          locale="es-ar"
          item-key="id"
          class="row-pointer"
          :item-class="rowClasses"
          :disable-sort="true"
          :items-per-page="500"
        ></v-data-table>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-data-table
          v-if="!sinTurnos"
          :headers="headerMiercoles"
          :items="this.listaTurnosMiercoles"
          dense
          @click:row="despliegaMenu"
          :hide-default-footer="true"
          :loading="isLoading"
          locale="es-ar"
          item-key="id"
          class="row-pointer"
          :item-class="rowClasses"
          :disable-sort="true"
          :items-per-page="500"
        >
        </v-data-table>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-data-table
          v-if="!sinTurnos"
          :headers="headerJueves"
          :items="this.listaTurnosJueves"
          dense
          @click:row="despliegaMenu"
          :hide-default-footer="true"
          :loading="isLoading"
          locale="es-ar"
          item-key="id"
          class="row-pointer"
          :item-class="rowClasses"
          :disable-sort="true"
          :items-per-page="500"
        ></v-data-table>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-data-table
          v-if="!sinTurnos"
          :headers="headerViernes"
          :items="this.listaTurnosViernes"
          dense
          @click:row="despliegaMenu"
          :hide-default-footer="true"
          :loading="isLoading"
          locale="es-ar"
          item-key="id"
          class="row-pointer"
          :item-class="rowClasses"
          :disable-sort="true"
          :items-per-page="500"
        >
        </v-data-table>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-data-table
          v-if="!sinTurnos"
          :headers="headerSabado"
          :items="this.listaTurnosSabado"
          dense
          class="row-pointer"
          @click:row="despliegaMenu"
          :hide-default-footer="true"
          :loading="isLoading"
          locale="es-ar"
          item-key="id"
          :item-class="rowClasses"
          :disable-sort="true"
          :items-per-page="500"
        >
        </v-data-table>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-data-table
          :headers="headerDomingo"
          :items="this.listaTurnosDomingo"
          dense
          v-if="listaTurnosDomingo.length > 0 && !sinTurnos"
          class="row-pointer"
          @click:row="despliegaMenu"
          :hide-default-footer="true"
          :loading="isLoading"
          locale="es-ar"
          item-key="id"
          :item-class="rowClasses"
          :disable-sort="true"
          :items-per-page="500"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-alert
      color="blue"
      dark
      outlined
      v-if="
        listaTurnosLunes.length == 0 &&
        listaTurnosMartes.length == 0 &&
        listaTurnosMiercoles.length == 0 &&
        listaTurnosJueves.length == 0 &&
        listaTurnosViernes.length == 0 &&
        listaTurnosSabado.length == 0 &&
        listaTurnosDomingo.length == 0
      "
      class="mb-0 mt-2"
      >{{
        sinTurnos
          ? "Profesional sin turnos disponibles"
          : "No hay turnos disponibles esta semana."
      }}</v-alert
    >
    <v-dialog v-model="showModalMedicamentos" max-width="600" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showModalMedicamentos = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Ingrese los medicamentos solicitados</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-4">
          <v-textarea
            v-model="medicamentos"
            label="Medicamentos solicitados *"
            placeholder="Ingrese los medicamentos que necesita"
            outlined
            :rules="medicamentosRules"
            rows="5"
            counter
            autofocus
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="showModalMedicamentos = false">Cancelar</v-btn>
          <v-btn color="success" @click="confirmarReceta">Confirmar Receta</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click.stop="volver()">Volver</v-btn>
    </v-card-actions>
  </div>
</template>
<style lang="scss" scoped>
.turnos-wide-toolbar {
  margin-top: 1rem;
  padding-bottom: 0.5rem;
  :deep(.v-text-field) {
    margin-top: -12px;
  }
}
.referencia-turno-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-left: 2rem;
}
.referencia-tipo-turno {
  padding: 8px 16px;
  color: white;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 260px;
  &__presencial {
    background-color: #4caf50;
  }
  &__videoconsulta {
    background-color: purple;
  }
  &__elige-paciente {
    background-color: orange;
  }
}
.loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

::v-deep .v-data-table__empty-wrapper {
  display: none;
}
::v-deep .v-data-table__wrapper {
  color: white;
  font-weight: bold;

  height: fit-content;
}
::v-deep .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 38px;
  font-size: 0.67rem;
  border: 0.5px solid;
}
::v-deep .v-data-table__wrapper > table > tbody > tr.dos > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr.dos > td {
  height: 76px;
  font-size: 0.67rem;
  border: 0.5px solid;
}
::v-deep .v-data-table__wrapper > table > tbody > tr.tres > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr.tres > td {
  height: 114px;
  font-size: 0.67rem;
  border: 0.5px solid;
}
::v-deep .v-data-table__wrapper > table > tbody > tr.cuatro > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr.cuatro > td {
  height: 152px;
  font-size: 0.67rem;
  border: 0.5px solid;
}
::v-deep .v-data-table__wrapper > table > tbody > tr.cinco > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr.cinco > td {
  height: 190px;
  font-size: 0.67rem;
  border: 0.5px solid;
}
::v-deep .v-data-table__wrapper > table > tbody > tr.seis > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr.seis > td {
  height: 228px;
  font-size: 0.67rem;
  border: 0.5px solid;
}
::v-deep .v-data-table__wrapper > table > tbody > tr.siete > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr.siete > td {
  height: 266px;
  font-size: 0.67rem;
  border: 0.5px solid;
}
::v-deep .v-data-table__wrapper > table > tbody > tr.ocho > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr.ocho > td {
  height: 304px;
  font-size: 0.67rem;
  border: 0.5px solid;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  color: rgb(0, 0, 0);
}
.row-pointer :deep(tbody) tr :hover {
  cursor: pointer;
}
.row-pointer :deep(tbody) tr :hover {
  cursor: pointer;
}
td {
  border-bottom: 1px solid thin #fff;
}
.orange {
  background-color: orange;
}
.v-application .uno :deep(tbody) tr {
  height: 76px !important;
}
.red {
  background-color: red;
}
.dos >>> tbody tr {
  height: 76px !important;
}
.blue {
  background-color: blue;
}
.purple {
  background-color: purple;
}
.grey {
  background-color: grey;
}
</style>

<script>
import axios from "../../axios-auth.js";
import router from "../../router/index.js";
import moment from "moment";

export default {
  name: "GestionTurnos",
  props: [
    "idProfesional",
    "idInstitucion",
    "listaLunes",
    "listaMartes",
    "listaMiercoles",
    "listaJueves",
    "listaViernes",
    "listaSabado",
    "listaDomingo",
    "headerL",
    "headerM",
    "headerMi",
    "headerJ",
    "headerV",
    "headerS",
    "headerD",
    "fechaMinima",
    "fechaMaxima",
    "idObraSocial",
    "tipoDeTurno",
    "nombreProfesional",
    "loading",
    "nroAfiliado",
    "initialDate",
    "modalidad",
  ],
  data: (vm) => ({
    clase: "",
    dialog: false,
    alert: false,
    showNuevoTurno: false,
    showEditarTurno: false,
    showColores: false,
    showMenu: false,
    precioInfo: null,
    x: 0,
    y: 0,
    itemsMenu: [],
    showNuevoCobro: false,
    valid: true,
    medicamentos: "",
    medicamentosRules: [
      (v) => (v && v.trim().length > 0) || "El campo de medicamentos es obligatorio",
    ],
    showModalMedicamentos: false,
    turnoSeleccionado: null,
    videoConsultaSeleccionada: null,
    copiar: 0,
    name: "",
    refrescarPantalla: false,
    interval: null,
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    select: null,
    expanded: [],
    singleExpand: false,
    search: "",

    headersLength: {
      type: Number,
    },
    editedIndex: -1,
    editedItem: {
      hora: "",
      paciente: "",
    },
    defaultItem: {
      hora: "",
      paciente: "",
    },
    date: vm.toISOLocal(new Date()),
    dateFormatted: vm.formatDate(vm.toISOLocal(new Date())),
    menu: false,
    modal: false,
    menu2: false,
    prof: "",
    profs: [],
    diaSemana: null,
    on: null,
    horaTurno: "",
    itemCopia: {
      idTurno: null,
      tiempoTurno: null,
      cantIntervalos: null,
    },
    loadingTurnos: false,
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
    initialDate: {
      immediate: true,
      handler(val) {
        this.date = val;
        this.dateFormatted = moment(val).format("DD/MM/YYYY");
      },
    },
    tipoDeTurno: {
      immediate: true,
      handler() {
        this.cargarPrecioInfo();
      },
    },
  },
  computed: {
    precioDisplay() {
      if (this.tipoDeTurno && this.tipoDeTurno.precioConsultaString) return this.tipoDeTurno;
      return this.precioInfo;
    },
    hayTurnosPresenciales() {
      return (
        this.listaLunes.some((turno) => turno.tipoTurno === 0) ||
        this.listaMartes.some((turno) => turno.tipoTurno === 0) ||
        this.listaMiercoles.some((turno) => turno.tipoTurno === 0) ||
        this.listaJueves.some((turno) => turno.tipoTurno === 0) ||
        this.listaViernes.some((turno) => turno.tipoTurno === 0) ||
        this.listaSabado.some((turno) => turno.tipoTurno === 0) ||
        this.listaDomingo.some((turno) => turno.tipoTurno === 0)
      );
    },
    hayTurnosVideoconsulta() {
      return (
        this.listaLunes.some((turno) => turno.tipoTurno === 1) ||
        this.listaMartes.some((turno) => turno.tipoTurno === 1) ||
        this.listaMiercoles.some((turno) => turno.tipoTurno === 1) ||
        this.listaJueves.some((turno) => turno.tipoTurno === 1) ||
        this.listaViernes.some((turno) => turno.tipoTurno === 1) ||
        this.listaSabado.some((turno) => turno.tipoTurno === 1) ||
        this.listaDomingo.some((turno) => turno.tipoTurno === 1)
      );
    },
    hayTurnosEligePaciente() {
      return (
        this.listaLunes.some((turno) => [2, 3].includes(turno.tipoTurno)) ||
        this.listaMartes.some((turno) => [2, 3].includes(turno.tipoTurno)) ||
        this.listaMiercoles.some((turno) => [2, 3].includes(turno.tipoTurno)) ||
        this.listaJueves.some((turno) => [2, 3].includes(turno.tipoTurno)) ||
        this.listaViernes.some((turno) => [2, 3].includes(turno.tipoTurno)) ||
        this.listaSabado.some((turno) => [2, 3].includes(turno.tipoTurno)) ||
        this.listaDomingo.some((turno) => [2, 3].includes(turno.tipoTurno))
      );
    },
    sinTurnos() {
      return this.date == this.fechaMinima && this.date >= this.fechaMaxima;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Turno" : "Editar Turno";
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    isLoading: {
      get() {
        return this.loading;
      },
    },
    listaTurnosLunes: {
      get() {
        return this.listaLunes;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    listaTurnosMartes: {
      get() {
        return this.listaMartes;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    listaTurnosMiercoles: {
      get() {
        return this.listaMiercoles;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    listaTurnosJueves: {
      get() {
        return this.listaJueves;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    listaTurnosViernes: {
      get() {
        return this.listaViernes;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    listaTurnosSabado: {
      get() {
        return this.listaSabado;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    listaTurnosDomingo: {
      get() {
        return this.listaDomingo;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    headerLunes: {
      get() {
        return this.headerL;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    headerMartes: {
      get() {
        return this.headerM;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    headerMiercoles: {
      get() {
        return this.headerMi;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    headerJueves: {
      get() {
        return this.headerJ;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    headerViernes: {
      get() {
        return this.headerV;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    headerSabado: {
      get() {
        return this.headerS;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
    headerDomingo: {
      get() {
        return this.headerD;
      },
      set(value) {
        if (value != []) {
          this.$emit("buscarTurnos", this.date);
        }
      },
    },
  },
  created() {
    this.setToday();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    volver() {
      this.setToday();
      this.$emit("goToStep3");
    },

    setToday() {
      var hoy = new Date().getDay();
      if (hoy == 0) hoy = 6;
      else hoy -= 1;
      let dias = 1000 * 60 * 60 * 24 * hoy;

      let resta = new Date().getTime() - dias;
      this.date = this.toISOLocal(new Date(resta));
      this.dateFormatted = moment(resta).format("DD/MM/YYYY");
    },

    setClasses(item) {
      return "row-pointer";
    },
    salir() {
      router.push("/Home");
    },
    getText(seleccionaVideoConsulta) {
      let texto = "";
      if (seleccionaVideoConsulta === null) {
        texto = "¿Desea registrar el turno?";
      } else if (seleccionaVideoConsulta === false) {
        texto = "¿Desea registrar el turno presencial?";
      } else {
        texto = "¿Desea registrar el turno de videoconsulta?";
      }
      return texto;
    },
    getPrecioHtml() {
      // Intentar obtener info de precio de tipoDeTurno (viene del modal) o de precioInfo (consultado al backend)
      const fuente = (this.tipoDeTurno && this.tipoDeTurno.precioConsultaString)
        ? this.tipoDeTurno
        : this.precioInfo;

      if (!fuente || !fuente.precioConsultaString) return "";
      const esSena = fuente.esSena;
      const precioConsulta = fuente.precioConsultaString;
      const precioFinal = fuente.precioFinalString;
      if (esSena && precioFinal) {
        return `<div style="margin-top:12px;padding:10px;border-radius:8px;background:#FFF3E0;border:1px solid #FF9800;">
          <div style="font-size:0.9rem;color:#E65100;font-weight:600;">💰 Información de pago</div>
          <div style="font-size:0.85rem;margin-top:4px;"><b>Seña requerida:</b> ${precioConsulta}</div>
          <div style="font-size:0.85rem;"><b>Precio total consulta:</b> ${precioFinal}</div>
        </div>`;
      } else if (precioConsulta) {
        return `<div style="margin-top:12px;padding:10px;border-radius:8px;background:#E8F5E9;border:1px solid #4CAF50;">
          <div style="font-size:0.9rem;color:#2E7D32;font-weight:600;">💰 Precio de la consulta: ${precioConsulta}</div>
        </div>`;
      }
      return "";
    },
    async cargarPrecioInfo() {
      this.precioInfo = null;
      if (!this.idProfesional || !this.idObraSocial) return;
      try {
        const { data } = await axios.get("/PortalPaciente/GetPrecioInfoWeb", {
          params: {
            idProfesional: this.idProfesional,
            idObraSocial: this.idObraSocial,
            idTipoTurno: this.tipoDeTurno?.idTipoTurno || 0,
          },
        });
        this.precioInfo = data;
      } catch {
        this.precioInfo = null;
      }
    },
    guardarTurno(item, seleccionaVideoConsulta = null) {
      // Si es modalidad receta, abrir modal de medicamentos
      if (this.modalidad === "receta") {
        this.turnoSeleccionado = item;
        this.videoConsultaSeleccionada = seleccionaVideoConsulta;
        this.showModalMedicamentos = true;
        return;
      }

      this.loadingTurnos = true;
      this.$swal({
        title: "Guardar Turno",
        html: this.getText(seleccionaVideoConsulta) + this.getPrecioHtml(),
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosTurno = {
            idInstitucion: this.idInstitucion,
            idUsuarioPaciente: this.$store.state.idUsuarioPaciente,
            fechaTurnoString: item.fechaTurnoString,
            horaInicioString: item.hora,
            duracionTurno: item.tiempoTurno,
            idObraSocial: this.idObraSocial,
            idTipoTurno: this.tipoDeTurno?.idTipoTurno,
            siglaTipoTurno: this.tipoDeTurno?.sigla || "",
            idProfesional: this.idProfesional,
            nroAfiliado: this.nroAfiliado,
            seleccionaVideoConsulta,
            esReceta: this.modalidad === "receta",
            medicamentos: this.modalidad === "receta" ? this.medicamentos : "",
          };

          let self = this;
          axios
            .post("/PortalPaciente/GuardarTurno", datosTurno)
            .then((response) => {
              if (response.data == "Reservado") {
                self.showAlert({
                  icon: "error",
                  title:
                    "Disculpe, el turno acaba de ser tomado. Reserve otro por favor",
                  vm: self,
                });
              } else {
                if (response.data && response.data != "Reservado") {
                  self
                    .$swal({
                      title: !response.data.obligaPago
                        ? "Turno reservado. Se enviará un mail a su cuenta de correo electrónico con el comprobante del turno y el link de pago. Revise por favor su correo no deseado o spam. El turno requiere ser abonado."
                        : `Turno reservado de forma provisoria. Se enviará un mail con el comprobante del turno y el link de pago. Revise también su carpeta de correo no deseado o spam. ⚠️ Importante: el turno será confirmado una vez acreditado el pago. Para conservar la reserva, el pago debe realizarse ${
                            !response.data.cantDiasReservaPago
                              ? "en el transcurso del día"
                              : "hasta mañana inclusive"
                          }.`,
                      icon: "success",
                      type: "success",
                      showCancelButton: true,
                      background: "#ececec",
                      confirmButtonText: "Pagar Consulta",
                      cancelButtonText: "No en este momento",
                      showCloseButton: true,
                      showLoaderOnConfirm: true,
                    })
                    .then((result) => {
                      if (result.value) {
                        window.open(response.data.link, "_blank");
                      }
                    });
                } else {
                  self.showAlert({
                    icon: "success",
                    title:
                      "Turno reservado. Se enviará un mail a su cuenta de correo electrónico. Revise por favor su correo no deseado o spam.",
                    vm: self,
                  });
                }
                self.$emit("turnoRegistrado");
              }
              self.loadingTurnos = false;
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El turno no pudo ser reservado",
                vm: this,
              });
              self.loadingTurnos = false;
            });
        } else {
          this.loadingTurnos = false;
        }
      });
    },
    confirmarReceta() {
      if (!this.medicamentos || !this.medicamentos.trim()) {
        this.$swal.fire({
          icon: "error",
          title: "El campo de medicamentos es obligatorio",
          showConfirmButton: false,
          background: "#ececec",
          timer: 3500,
        });
        return;
      }
      this.showModalMedicamentos = false;
      this.guardarTurnoFinal(this.turnoSeleccionado, this.videoConsultaSeleccionada);
    },
    guardarTurnoFinal(item, seleccionaVideoConsulta) {
      this.loadingTurnos = true;
      this.$swal({
        title: "Guardar Turno",
        html: this.getText(seleccionaVideoConsulta) + this.getPrecioHtml(),
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosTurno = {
            idInstitucion: this.idInstitucion,
            idUsuarioPaciente: this.$store.state.idUsuarioPaciente,
            fechaTurnoString: item.fechaTurnoString,
            horaInicioString: item.hora,
            duracionTurno: item.tiempoTurno,
            idObraSocial: this.idObraSocial,
            idTipoTurno: this.tipoDeTurno?.idTipoTurno,
            siglaTipoTurno: this.tipoDeTurno?.sigla || "",
            idProfesional: this.idProfesional,
            nroAfiliado: this.nroAfiliado,
            seleccionaVideoConsulta,
            esReceta: true,
            medicamentos: this.medicamentos,
          };

          let self = this;
          axios
            .post("/PortalPaciente/GuardarTurno", datosTurno)
            .then((response) => {
              if (response.data == "Reservado") {
                self.showAlert({
                  icon: "error",
                  title: "Disculpe, el turno acaba de ser tomado. Reserve otro por favor",
                  vm: self,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Su pedido de receta ha sido registrado exitosamente",
                  vm: self,
                });
                self.$emit("turnoRegistrado");
              }
              self.loadingTurnos = false;
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El turno no pudo ser reservado",
                vm: self,
              });
              self.loadingTurnos = false;
            });
        } else {
          this.loadingTurnos = false;
        }
      });
    },
    retrocederSemana() {
      let dias = 1000 * 60 * 60 * 24 * 6;
      let resta = new Date(this.date).getTime() - dias;
      this.date = this.toISOLocal(new Date(resta));
      this.dateFormatted = moment(resta).format("DD/MM/YYYY");
      this.armarTurnos();
    },
    avanzarSemana() {
      let dias = 1000 * 60 * 60 * 24 * 8;
      let resta = new Date(this.date).getTime() + dias;
      this.date = this.toISOLocal(new Date(resta));
      this.dateFormatted = moment(resta).format("DD/MM/YYYY");
      this.armarTurnos();
    },
    definirAccion(item) {
      if (item.title === "Reservar Turno") this.guardarTurno(this.editedItem);
      if (item.title === "Reservar Turno Presencial")
        this.guardarTurno(this.editedItem, false);
      if (item.title === "Reservar Turno Videoconsulta")
        this.guardarTurno(this.editedItem, true);
    },
    rowClasses(item) {
      console.log("item", item);
      if ([2, 3].includes(item.tipoTurno)) {
        return "orange";
      } else if (item.tipoTurno === 1) {
        return "purple";
      }
      return "green";
    },
    despliegaMenu(item, row) {
      this.itemsMenu = [];

      if ([2, 3].includes(item.tipoTurno)) {
        this.itemsMenu.push({
          title: "Reservar Turno Presencial",
          icon: "mdi-walk",
        });
        this.itemsMenu.push({
          title: "Reservar Turno Videoconsulta",
          icon: "mdi-video",
        });
      } else {
        this.itemsMenu.push({ title: "Reservar Turno", icon: "mdi-calendar" });
      }

      this.x = event.clientX;
      this.y = event.clientY;
      this.editedItem = item;
      this.showMenu = !this.showMenu;
    },

    allowedDates: (val) => new Date(val).getDay() === 0,

    allowedDates: (val) => new Date(val).getDay() === 0,

    armarHeaders() {
      this.headerLunes = 1;
    },
    armarTurnos() {
      this.listaTurnosLunes = 1;
      this.dateFormatted = moment(this.date).format("DD/MM/YYYY");
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 3800,
      });
    },
    mostrarColores() {
      this.showColores = true;
    },
    calcularHora(hora) {
      var division = hora.split(":");
      var hoy = new Date();
      var fecha = new Date(
        hoy.getYear(),
        hoy.getMonth(),
        hoy.getDay(),
        division[0],
        parseInt(division[1] - 1),
      );
      var minutos = fecha.getMinutes().toString();
      if (minutos.length == 1) minutos = "0" + minutos;
      var horaNueva = fecha.getHours() + ":" + minutos;
      return horaNueva;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 3500,
      });
    },
  },
};
</script>
